import { sizes } from '../sizing.js';
import { space } from '../spacing.js';
import { fontWeights } from '../typography.js';
export const control = {
    maxWidth: sizes.x80,
};
export const selectedLabel = {
    fontWeight: fontWeights.standard,
};
export const input = {
    marginBottom: space.x2,
    marginRightLeft: space.x3,
    marginTop: space.x0,
};
export const item = {
    height: sizes.x9,
};
export const loadingSpinner = {
    paddingBottom: space.x2,
};
export const itemDescription = {
    fontSize: 'xs',
    lineHeight: 'xs',
    color: 'secondary',
};
//# sourceMappingURL=select.js.map